import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-12 md:py-20 bg-accent-600 text-white relative overflow-hidden" data-id="element-82">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop')] opacity-10 bg-cover bg-center mix-blend-overlay" data-id="element-83"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-brand-950/80 to-transparent" data-id="element-84"></div>

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-86">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-3 md:mb-6" data-id="element-87">
            Acceso inmediato
          </h2>
          <p className="text-base md:text-2xl font-medium mb-6 md:mb-10 text-brand-50" data-id="element-88">
            Hacé clic y empezá hoy mismo.
          </p>
          <Button href="#comprar" variant="secondary" size="lg" className="shadow-2xl md:!px-10 md:!py-5 md:!text-xl" data-id="element-89">
            Acceder ahora
          </Button>
        </motion.div>
      </div>
    </section>;
}